import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AuthGuardService } from "./services/auth-guard";
// Layouts
import { FullLayoutComponent } from "./layouts/full-layout.component";
import { SimpleLayoutComponent } from "./layouts/simple-layout.component";

export const routes: Routes = [
  {
    path: "",
    redirectTo: "",
    pathMatch: "full",
  },
  {
    path: "",
    canActivate: [AuthGuardService],
    component: FullLayoutComponent,
    data: {
      title: "Home",
    },
    children: [
      { path: "", pathMatch: "full", redirectTo: "dashboard" },
      {
        path: "dashboard",
        loadChildren:
          "./dashboard/admin-dashboard/dashboard.module#DashboardModule",
      },
      {
        path: "club-dashboard",
        loadChildren:
          "./dashboard/club-dashboard/dashboard.module#DashboardModule",
      },
      {
        path: "tour-dashboard",
        loadChildren:
          "./dashboard/tour-dashboard/dashboard.module#DashboardModule",
      },
      {
        path: "committee-dashboard",
        loadChildren:
          "./dashboard/committee-dashboard/dashboard.module#DashboardModule",
      },
      {
        path: "company-dashboard",
        loadChildren:
          "./dashboard/company-dashboard/dashboard.module#DashboardModule",
      },
      {
        path: "society-dashboard",
        loadChildren:
          "./dashboard/society-dashboard/dashboard.module#DashboardModule",
      },
      {
        path: "components",
        loadChildren: "./components/components.module#ComponentsModule",
      },
    ],
  },
  {
    path: "login",
    component: SimpleLayoutComponent,
    data: {
      title: "Pages",
    },
    children: [
      {
        path: "",
        loadChildren: "./pages/pages.module#PagesModule",
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: "reload",
      useHash: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
